export default __webpack_public_path__ + "static/media/connect-vpn-2.3adae69c.png";